import React from "react";

const BannerSlide = (props) => {
  return (
    <div className="relative w-full float-left" key={props.id}>
      <img src={props.imgurl} alt="banner" className="w-full h-[500px] max-sm:object-cover object-left" />
      <div className="absolute top-0 w-[550px] flex-col right-9 h-full flex justify-center max-sm:w-full max-sm:justify-end left-0 lg:left-auto">
        <div className="bg-black bg-opacity-50 p-4 lg:p-8">
          <h1 className="text-white text-md lg:text-3xl font-bold mb-3">{props.text}</h1>
          <button className="bg-white rounded-sm p-2">SHOP NOW</button>
        </div>
      </div>
    </div>
  );
};

export default BannerSlide;
